import styled from "styled-components";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

export const StyledPanelIcon = styled(SWReactIcons)`
    margin-left: 34px;
    margin-right: 6px;

    & svg path {
        fill: ${colorsPalettes.carbon["0"]};
    }
`;

export const StyledCloseButton = styled(IconButton)`
    margin-right: 8px;

    .SWReactIcons {

        & svg path {
            fill: ${colorsPalettes.carbon["0"]};
            stroke: ${colorsPalettes.carbon["0"]};
        }
    }

    &:hover {
        .SWReactIcons {
            & svg path {
                fill: ${colorsPalettes.carbon["0"]};
                stroke: ${colorsPalettes.carbon["0"]};
            }
        }
    }
`;

export const StyledInnerContainer = styled.div`
    align-items: center;
    display: flex;
`;

export const StyledPanelInner = styled.div`
    align-items: center;
    display: flex;

    & > *:not(:last-child) {
        margin-right: 20px;
    }
`;

export const StyledWrapper = styled.div`
    align-items: center;
    background-color: ${colorsPalettes.blue["400"]};
    display: flex;
    height: 100%;
    justify-content: space-between;
    width: 100%;
`;
